const PARENT_OPENABLE_LESSON_KEYS = ['on_checking', 'completed'] as const;
const PARENT_OPENABLE_LESSON_STATUSES = [1, 2] as const;

interface ICanParentOpenProgramLessonArgs {
	isAcademyService: boolean;
	isParent: boolean;
	lessonStatus?: number | null;
	lessonsKey: PropertyKey;
}

function canParentOpenProgramLesson({
	isAcademyService,
	isParent,
	lessonStatus,
	lessonsKey,
}: ICanParentOpenProgramLessonArgs) {
	if (!isParent || !isAcademyService) {
		return false;
	}

	if (
		PARENT_OPENABLE_LESSON_KEYS.includes(
			lessonsKey as (typeof PARENT_OPENABLE_LESSON_KEYS)[number],
		)
	) {
		return true;
	}

	return lessonsKey === 'all_lessons'
		? PARENT_OPENABLE_LESSON_STATUSES.includes(
				lessonStatus as (typeof PARENT_OPENABLE_LESSON_STATUSES)[number],
			)
		: false;
}

export default canParentOpenProgramLesson;
